import React from 'react'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'

import BusinessSection from '@/business-section'

import './styles.css'

const SectionMeaningfulData = ({ data, gray }) => {
  return (
    <BusinessSection
      title="Meaningful data"
      subtitle="View results by demographics, heat maps & more"
      gray={gray}
    >
      <div className="flex items-center flex-wrap">
        <div className="w-100 w-42-m">
          <Img
            sizes={data.meaningfulImg1.sizes}
            alt="Meaningful data, View results by demographics, heat maps & more"
          />
        </div>
        <div className="w-100 w-58-m">
          <Img
            sizes={data.meaningfulImg2.sizes}
            alt="Meaningful data, View results by demographics, heat maps & more"
          />
        </div>
      </div>
    </BusinessSection>
  )
}

SectionMeaningfulData.propTypes = {
  data: PropTypes.object,
  gray: PropTypes.bool
}

export default SectionMeaningfulData



// WEBPACK FOOTER //
// ./src/components/section-meaningful/section-meaningful.js